<template>
  <DxPopup
    v-if="isModal"
    :visible="show"
    :show-title="true"
    :title="title"
    :width="1100"
    :height="650"
    :show-close-button="true"
    :drag-enabled="false"
    @hiding="closeModal"
  >
    <div class="parcel-add-edit-container-modal">
      <StepsPanelWrapper
        ref="stepsWrapper"
        :steps="steps"
        :current-step.sync="currentStep"
        :step-props-fn="getStepProps"
        @step-input="onStepInput"
        @title="updateTitle"
      />
      <ParcelRightPanel :value="data" :saving="saving" @save="saveModal" @goto-list="closeModal" />
    </div>
  </DxPopup>
  <div class="view" v-else v-cloak>
    <EditCreateTitleBox :label="title" />
    <div class="parcel-add-edit-container">
      <StepsPanelWrapper
        ref="stepsWrapper"
        :steps="steps"
        :current-step.sync="currentStep"
        :step-props-fn="getStepProps"
        @step-input="onStepInput"
        @title="updateTitle"
      />
      <ParcelRightPanel :value="data" :saving="saving" @save="save" @goto-list="gotoList" />
    </div>
  </div>
</template>
<script>
import ParcelDetailsContent from "./partials/ParcelDetails.vue";
import EditCreateTitleBox from "@/components/Common/EditCreateTitleBox.vue";
import StepsPanelWrapper from "@/components/Common/StepsPanelWrapper.vue";
import ParcelRightPanel from "./partials/ParcelRightPanel.vue";
import DxPopup from "devextreme-vue/popup";

export default {
  name: "ParcelDetails",
  components: {
    ParcelDetailsContent,
    EditCreateTitleBox,
    StepsPanelWrapper,
    ParcelRightPanel,
    DxPopup,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    defaultNewValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: "",
      data: {
        uuid: "",
        name: "",
        remote_id: "",
        season_uuid: "",
        culture_uuid: "",
        department_uuid: "",
        parcel_group_uuid: "",
        surface: "",
        is_group: 0,
        is_deletable: true,
        settlement: "",
      },
      saving: false,
      steps: [
        {
          number: 1,
          label: this.$t("common.parcels"),
          component: ParcelDetailsContent,
          ref: "parcelDetailsStep",
        },
      ],
      currentStep: 1,
    };
  },
  computed: {
    name() {
      return this.$t("common.parcels");
    },
  },
  methods: {
    updateTitle() {
      const details = this.getDetailsComponent();
      if (details && details.title) {
        this.title = details.title;
        return;
      }

      this.title = this.data?.uuid ? this.$t("common.edit") : this.$t("common.new");
    },
    saveModal() {
      this.saving = true;
      const details = this.getDetailsComponent();
      if (!details || typeof details.save !== "function") {
        this.saving = false;
        return;
      }

      details
        .save()
        .then((data) => {
          this.saving = false;
          this.closeModal();
          this.$emit("newParcelCreated", data);
        })
        .catch(() => {
          this.saving = false;
        });
    },
    save() {
      const details = this.getDetailsComponent();
      if (!details || typeof details.save !== "function") {
        return;
      }

      this.saving = true;
      Promise.resolve(details.save()).finally(() => {
        this.saving = false;
      });
    },
    gotoList() {
      const details = this.getDetailsComponent();
      if (details && typeof details.gotoList === "function") {
        details.gotoList();
        return;
      }

      this.$router.push({
        path: "/works/parcels",
      });
    },
    getDetailsComponent() {
      return this.$refs.stepsWrapper?.$refs?.parcelDetailsStep || null;
    },
    getStepProps() {
      return {
        defaultNewValues: this.defaultNewValues,
        isModal: this.isModal,
        parcelData: this.data,
      };
    },
    onStepInput(step, payload) {
      this.data = payload ? { ...payload } : {};
      this.updateTitle();
    },
    closeModal() {
      this.$emit("close");
    },
  },
  mounted() {
    this.updateTitle();
  },
};
</script>

<style scoped>
.view {
  height: calc(100% - 70px);
}

.parcel-add-edit-container {
  display: flex;
  height: 100%;
  width: 100%;
}

.parcel-add-edit-container-modal {
  display: flex;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

<style>
.parcel-add-edit-container-modal .steps-panel-content {
  padding: 0px !important;
}
</style>
